import { render, staticRenderFns } from "./allTest.vue?vue&type=template&id=2df95758&scoped=true&"
import script from "./allTest.vue?vue&type=script&lang=js&"
export * from "./allTest.vue?vue&type=script&lang=js&"
import style0 from "./allTest.vue?vue&type=style&index=0&id=2df95758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df95758",
  null
  
)

export default component.exports